import { Translations } from './translations';

export const en: Translations = {
  nav: {
    services: 'Services',
    innovation: 'Innovation',
    about: 'About',
    getInTouch: 'Get in Touch',
    openMenu: 'Open navigation menu',
    closeMenu: 'Close navigation menu',
  },
  connectedCareHero: {
    healthForAll: 'Health for all,',
    anytime: 'Anytime',
    anywhere: 'Anywhere',
    fullHeadline: 'Health for all, Anytime Anywhere',
    subtitle: 'VIDAVO develops digital health solutions that connect people, data, and care teams to improve everyday healthcare.',
    exploreServices: 'Explore our services',
    discoverVida24: 'Discover Vida24',
    keywords: {
      secondOpinion: 'Second opinion',
      telemedicine: 'Telemedicine',
      smartNutrition: 'Smart nutrition',
      selfManagement: 'Self-management',
      digitalTherapeutics: 'Digital therapeutics',
      eWellness: 'eWellness',
      behaviorChange: 'Behavior change–mindfulness',
      mentalHealth: 'Mental health',
    },
  },
  hero: {
    badge: 'Digital Health Innovation',
    title: 'Your Digital Healthcare Expert',
    subtitle: 'From strategy to full-scale deployment, VIDAVO supports every stage of your digital health journey.',
  },
  trustedBy: {
    title: 'The Vida24 Digital Health Ecosystem',
    subtitle: 'All-in-one telehealth ecosystem for monitoring, decision support, and integrated care.',
    description: "VIDAVO's all-in-one digital health ecosystem that brings patients, healthcare professionals, and organisations together. It enables continuous monitoring through wearables and medical devices, secure data sharing, and clinical dashboards that support better decisions and healthier lives.",
    learnMore: 'Learn more about Vida24',
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: "Get answers to common questions about VIDAVO's digital health solutions and services.",
    faqs: {
      question1: 'What makes VIDAVO different in digital health?',
      answer1: 'VIDAVO combines deep healthcare expertise with certified technology, offering modular solutions that are clinically safe, user-friendly, and ready to scale.',
      question2: 'What is Vida24?',
      answer2: 'Vida24 is our flagship digital health ecosystem. It connects patients, professionals, and organisations through remote monitoring, secure data sharing, and smart dashboards.',
      question3: "Are VIDAVO's solutions certified?",
      answer3: 'Yes. Vida24 is CE certified under the Medical Device Directive (MDD) and is currently in the process of obtaining certification under the EU Medical Device Regulation (MDR). All VIDAVO processes and products are GDPR-compliant and supported by ISO-certified quality and security standards.',
      question4: 'Who do you work with?',
      answer4: 'We work with hospitals, healthcare providers, research institutions, municipalities, and industry partners who want to implement reliable digital health solutions.',
      question5: 'How do you support clients after deployment?',
      answer5: 'We provide training, technical assistance, and continuous updates to ensure that solutions remain reliable, secure, and effective over time.',
      question6: 'Can VIDAVO develop new apps or software beyond Vida24?',
      answer6: 'Absolutely. We provide Vida24 as SaaS, offer white-label solutions for partners, and develop custom apps tailored to client needs.',
    },
  },
  rdMenu: {
    researchOnDemand: 'Research on Demand',
    rdPortfolio: 'R&D Project Portfolio',
    buildingInnovation: 'Building Innovation',
    digitalTransformation: 'Digital Transformation',
  },
  digitalTransformation: {
    badge: 'DIGITAL TRANSFORMATION',
    title: 'Vida24',
    subtitle: 'Project code: 108682',
    projectTitle: 'Advanced Telemedicine & Intelligence Upgrade',
    projectTitleContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    briefDescription: 'Brief Description',
    briefDescriptionContent: 'Investment in the scalability and high availability of Vida24 with the aim of commercial expansion across Europe.',
    investmentPlanBudget: 'Investment Plan Budget',
    investmentPlanBudgetContent: '€430,100.00',
    investmentPlanEuFunding: 'EU Funding',
    investmentPlanEuFundingContent: '€210,875.00',
    investmentPlanDisclaimer: 'This project is carried out within the framework of the National Recovery and Resilience Plan Greece 2.0, funded by the European Union – NextGenerationEU',
    logoAlt: 'Greece 2.0 National Recovery and Resilience Plan - Funded by the European Union NextGenerationEU',
  },
  buildingInnovation: {
    badge: 'BUILDING INNOVATION',
    title: 'Tomorrow\'s Healthcare',
    subtitle: 'Building innovation means working today on the solutions that healthcare will need tomorrow. Through our research endeavors, we explore emerging technologies, validate new methods, and co-create pathways with academic, clinical, and industry partners. We welcome consortia and stakeholders who want to be part of this journey and shape the future of health together.',
    focusAreasTitle: 'Innovation Focus Areas',
    focusAreasSubtitle: 'Explore our cutting-edge research domains shaping tomorrow\'s healthcare landscape',
    focusAreas: [
      'Artificial Intelligence for Clinical Decision Support',
      'AI for Population and Public Health',
      '6G and Next-Generation IoT',
      'Digital Twins in Healthcare',
      'Extended Reality (VR/AR/MR)',
      'Digital Biomarkers and Remote Sensing',
      'Sustainable and Green HealthTech',
      'Data Interoperability and Trust',
    ],
    partnerTitle: 'Partner With Us',
    partnerSubtitle: 'Join our ecosystem of innovation partners shaping the future of healthcare',
    partners: {
      academic: {
        title: 'Academic Partners',
        description: 'Universities and research institutions driving breakthrough discoveries'
      },
      healthcare: {
        title: 'Healthcare Providers',
        description: 'Hospitals and clinics implementing real-world solutions'
      },
      industry: {
        title: 'Industry Leaders',
        description: 'Technology companies and healthcare innovators'
      }
    }
  },
  researchOnDemand: {
    badge: 'R&D SOLUTIONS',
    title: 'Research on Demand',
    subtitle: 'Turning questions into outcomes',
    description: 'Research becomes valuable when it answers real needs. At Vidavo, we design and execute studies that generate practical insights for healthcare, industry, and policy. Our approach combines scientific rigor with a clear focus on applicability, ensuring that every project delivers results that can guide decisions, shape new solutions, or validate products.',
    whatWeOffer: 'What we offer',
    services: [
      {
        title: 'Tailored study design',
        description: 'From small-scale pilots to multicenter trials, we plan studies that fit the objectives and resources of our partners.',
      },
      {
        title: 'Clinical validation',
        description: 'Expertise in protocols that assess safety, performance, and usability of digital health technologies in real-world settings.',
      },
      {
        title: 'User and market research',
        description: 'Collection and analysis of feedback from patients, clinicians, and healthcare organizations to inform product development.',
      },
      {
        title: 'Data management and analytics',
        description: 'Secure infrastructures for collecting, processing, and interpreting health data with transparency and compliance.',
      },
      {
        title: 'Evaluation frameworks',
        description: 'Development of KPIs and outcome measures that demonstrate value in clinical, economic, or social terms.',
      },
    ],
    globalNetwork: {
      badge: 'WORLDWIDE PRESENCE',
      title: 'Global research network',
      description: 'Our research projects span across multiple countries, creating a comprehensive network of healthcare innovation and scientific collaboration that drives global health advancement.',
    },
    trackRecord: {
      title: 'Our track record',
      description: 'Over the past two decades we have supported European and national research projects, collaborated with universities and hospitals across multiple countries, and worked with private companies to bring new health technologies from concept to deployment. Our role has ranged from scientific coordination and clinical trials to technology development and impact assessment.',
    },
    stats: [
      { label: 'Years of experience' },
      { label: 'European and national research projects' },
      { label: 'Academic and clinical partners worldwide' },
      { label: 'Countries with project implementations' },
    ],
  },
  euNationalProjects: {
    badge: 'EU/NATIONAL PROJECTS',
    title: 'Recent Project Portfolio',
    subtitle: 'Our comprehensive portfolio of completed and ongoing research projects across Europe.',
    projectDescriptions: {
      marissa: 'A Horizon 2020 project that develops a digital platform to improve management of Type II Diabetes and Sarcopenia in older adults through personalized care, remote monitoring, and patient empowerment.',
      raise: 'A Horizon 2020 project that develops tele-rehabilitation solutions, enabling patients in remote areas to access continuous care and manage chronic conditions through the Vida24 system, connected medical devices, and remote support.',
      valueCare: 'A Horizon 2020 project that provides an integrated digital solution to support older people with chronic conditions, combining health and social care services to improve quality of life and care efficiency.',
      intelliot: 'A Horizon 2020 project that develops next-generation IoT solutions for healthcare, agriculture, and manufacturing, with Vidavo contributing to patient-centered digital support and remote health monitoring.',
      inspect: 'A project co-funded by the EU and national resources that develops intelligent hospital beds with embedded sensors to continuously monitor patients, detect early health risks, and prevent complications such as pressure ulcers.',
      pat: 'A project funded under the Greek Operational Programme «Competitiveness and Entrepreneurship» that developed a digital system for continuous monitoring and early detection of allergic respiratory diseases, helping patients and doctors manage symptoms and improve quality of life.',
      intelTriage: 'A project that develops an intelligent triage and monitoring system for hospital emergency departments, using biosensors and decision-support tools to prioritize care and track patients during their first 24 hours of admission.',
      liver3d: 'A research project co-funded by the EU and national resources that develops 3D-printed organ models to support surgical planning and training, enhancing precision and safety in medical procedures.',
      sefac: 'An EU-funded project that promotes prevention and self-management of chronic diseases by engaging citizens, healthcare providers, and volunteers in community-based activities and ICT-supported programs across four European pilot regions.',
      cyberCare: 'A project co-funded by the EU and national resources that develops a cybersecurity system to protect healthcare networks and connected medical devices, validated through a remote pregnancy care pilot in Greece.',
      im: 'A digital platform for managing oncology patients and chemotherapy protocols, providing automation, speed, and safety across all stages of treatment. Τhe project «IM» was implemented in the framework of the Action «Investment Plans of Innovation» of the Program «Central Macedonia», PARD 2021-2027», that is co-funded by the European Union and Greece',
      smartcare: 'A European project that developed ICT-supported care pathways to integrate health and social services, piloted in ten regions across Europe to improve coordination and delivery of citizen-centered care.',
      evolve2care: 'Funded by the European Union, EVOLVE2CARE advances HealthTech experimentation to strengthen collaboration between Living Labs and innovators in Transitional Care. The project supports the scale-up of VIDAVO\u2019s Vida24 platform, a CE-certified digital health solution for chronic disease management, through a non-clinical validation pilot. In collaboration with Good Tech Living Lab in Romania, it focuses on real-world validation of usability, patient engagement, clinical workflow fit, and ethical deployment.',
      cyberSuite: 'CyberSuite is a Digital Europe project supporting SMEs in adopting advanced cybersecurity solutions through an integrated Security-as-a-Service platform and marketplace. VIDAVO leads the Digital Health use case via its Vida24\u00ae platform, supporting the validation of CyberSuite solutions in a real-world healthcare environment, with a focus on cybersecurity monitoring, vulnerability assessment, and strengthening the cyber resilience of telehealth platforms.',
      cerebris: 'CEREBRIS is an EIC Pathfinder project developing a secure and explainable AI ecosystem for stroke care and neurological disease management. Combining clinical data, brain imaging, biosignals, and advanced AI models, the project supports more personalised rehabilitation and recovery prediction. VIDAVO contributes as the digital health platform partner, supporting interoperability, data capture, and integration within the wider CEREBRIS ecosystem.',
      default: 'An innovative healthcare technology project contributing to digital health transformation and improved patient care delivery.',
    },
    seeMore: 'See more',
    tapToFlip: 'Tap for details',
  },
  aboutMenu: {
    vidavoEU: 'Vidavo EU',
    vidavoIndia: 'VIDAVO Asia',
    vidavoThroughTime: 'Vidavo through time',
    whyUs: 'Why Us',
    investorRelations: 'Investor Relations',
    careers: 'Careers',
    vida24HomeCare: 'Vida24 for Home Care',
  },
  vidavoMiddleEast: {
    pageTitle: 'VIDAVO Middle East | Connected Care & AI Digital Health',
    metaDescription: 'VIDAVO brings connected care and AI-powered digital health solutions to the Middle East through the VIDA24 platform and AI healthcare development services.',
    badge: 'VIDAVO Middle East',
    aiBadge: 'AI',
    heroTitle: 'VIDAVO – Advancing Digital Health Through Connected Care and AI Innovation',
    heroSubtitle: 'Health for all, Anytime, Anywhere',
    heroLead: 'Transforming Healthcare Through Connected\u00A0Care',
    heroText: 'VIDAVO is a digital health company dedicated to transforming healthcare delivery through innovative connected care solutions. Our mission is to make healthcare more accessible, efficient and patient-centered by enabling healthcare services anytime, anywhere.',
    platformTitle: 'The VIDA24 Digital Health Platform',
    platformText: 'At the core of our ecosystem is VIDA24, a modular and scalable digital health platform that supports remote patient monitoring, telemedicine, chronic disease management, virtual care services and integrated healthcare workflows.\n\nThrough a unified environment, VIDA24 connects healthcare professionals, patients and medical devices, enabling real-time communication, monitoring and clinical decision support.',
    platformCta: 'Visit vida24.eu',
    aiTitle: 'AI-Powered Healthcare Solutions',
    aiText1: 'Artificial Intelligence is becoming an integral part of modern healthcare, and VIDAVO actively incorporates AI-powered capabilities into its solutions to enhance healthcare delivery. AI technologies can support data analysis, risk assessment, patient monitoring, clinical decision-making and workflow optimization, helping healthcare organizations improve efficiency and patient outcomes.',
    aiText2: 'Beyond platform solutions, VIDAVO also provides AI healthcare development services, supporting healthcare organizations, providers and partners in designing, developing and integrating AI-driven digital health applications tailored to their specific needs. By combining healthcare expertise, digital innovation and advanced technologies, we help organizations accelerate their digital transformation journey.',
    futureTitle: 'Shaping the Future of Digital Health',
    futureText: 'With extensive experience in digital health, telemedicine and connected care, VIDAVO continues to support healthcare systems and organizations in delivering smarter, more proactive and more accessible healthcare services for the future.',
    ctaTitle: 'Let\'s build connected care together',
    ctaText: 'Talk to our team about digital health and AI initiatives in the Middle East.',
    ctaButton: 'Contact us',
    readInArabic: 'Read this page in Arabic',
    tapToZoom: 'Tap to zoom',
    heroImageAlt: 'Healthcare professional using a tablet within a digital connected care environment.',
    applicationImageAlt: 'VIDA24 app displaying vital signs, care plan, and remote health monitoring.',
  },
  vidavoIndia: {
    pageTitle: 'VIDAVO Asia | Connected Care & Digital Health in India',
    metaDescription: 'VIDAVO Asia brings 25+ years of digital health experience and the VIDA24 platform to India, combining proven technology with local expertise.',
    badge: 'VIDAVO Asia',
    heroTitle: 'Bringing Connected Care to India',
    heroText: 'VIDAVO Asia brings VIDAVO\u2019s 25+ years of digital health experience and the VIDA24 platform to India, combining internationally proven technology with local expertise to support the digital transformation of healthcare.',
    heroImageAlt: 'VIDA24 digital health platform connecting care across India',
    whoWeAreTitle: 'VIDAVO Asia: Global Experience, Local Expertise',
    whoWeAreText: 'VIDAVO Asia represents VIDAVO S.A. in India, bringing over 25 years of experience in digital health and Connected Care to one of the world\u2019s fastest-growing healthcare markets.\n\nIn partnership with Mc&Me Techserve Pvt. Ltd., VIDAVO Asia combines internationally proven digital health solutions with local expertise to address the evolving needs of healthcare organizations across India.',
    platformLabel: 'VIDA24',
    platformTitle: 'One Platform. Multiple Possibilities.',
    platformText: 'VIDA24 is VIDAVO\u2019s modular and interoperable digital health platform, designed to connect patients, healthcare professionals and healthcare organizations across the continuum of care.\n\nFrom remote patient monitoring and telemedicine to chronic disease management and care coordination, VIDA24 enables more connected, efficient and patient-centered care.',
    demoButton: 'Request a Demo',
    solutionsTitle: 'Our Solutions',
    solutions: [
      { title: 'Connected Care', description: 'Continuous and coordinated care across settings.' },
      { title: 'Remote Patient Monitoring', description: 'Connected monitoring beyond hospital walls.' },
      { title: 'Telemedicine & Virtual Care', description: 'Remote access to healthcare professionals and services.' },
      { title: 'Chronic Disease Management', description: 'Continuous support for long-term conditions.' },
      { title: 'Care Coordination', description: 'Connecting multidisciplinary teams across the patient journey.' },
    ],
    innovationTitle: 'AI-Powered Digital Innovation',
    innovationText: 'VIDA24 incorporates AI-enabled capabilities for intelligent data analysis, risk identification, workflow optimization and advanced decision support — supporting healthcare professionals while keeping people at the center of care.',
    experienceTitle: 'International Experience. Local Perspective.',
    experienceText: 'For over 25 years, VIDAVO has collaborated with hospitals, healthcare organizations, research institutions, industry partners and public authorities to develop and deliver innovative digital health solutions.\n\nThrough VIDAVO Asia, this experience is combined with local expertise to support the evolving needs of the Indian healthcare ecosystem.',
    discoverTitle: 'Discover VIDAVO Asia',
    discoverText: 'Explore how VIDAVO Asia and our connected care solutions can support healthcare organizations in India.',
    contactButton: 'Contact Our Team',
    ctaEmail: 'india.remotecare@vidavo.eu',
  },
  vidavoEU: {
    badge: 'EU PROJECTS',
    title: 'Vidavo – Healthcare Anytime Anywhere, now also in Europe!',
    titlePart1: 'Vidavo – Healthcare Anytime Anywhere,',
    titleHighlight: 'now also in Europe!',
    subtitle: 'With Vidavo EU in Liège, Belgium, we are taking the first step in our international expansion, bringing our digital health solutions to healthcare organizations across Europe.',
    ctaButton: 'Contact – Collaborate with Vidavo EU',
    section1Title: 'Why Liège? Why Europe?',
    section1Intro: 'Liège is a strategic point for Vidavo\'s European growth, offering direct access to new healthcare collaboration opportunities and a supportive environment for digital health innovation. Through Vidavo EU, we are laying the foundations of our international presence and creating new prospects for partnerships with European healthcare organizations, based on the following pillars.',
    section1Cards: {
      card1Title: 'Development of collaborations and networks',
      card1Desc: '',
      card2Title: 'Deployment of Vidavo – Healthcare Anytime Anywhere solutions in new countries',
      card2Desc: '',
      card3Title: 'International healthcare initiatives',
      card3Desc: '',
    },
    section2Title: 'Vidavo EU Offices',
    section2Subtitle: 'Our new European location',
    section2AddressLabel: 'Address:',
    section2Address: 'Quai sur-Meuse 19, 4000 Liège, Belgium',
    section2EmailLabel: 'E-mail:',
    section2Email: 'VidavoEU@vidavo.eu',
    section2Footer: 'The office in Liège is now part of Vidavo\'s network of locations and serves as the launch point for the company\'s pan-European presence.',
    vida24Title: 'Vida24: A complete digital health ecosystem',
    vida24Intro: 'At the heart of Vidavo\'s solutions lies Vida24, a comprehensive digital health ecosystem designed for remote care and clinical workflow management, supporting:',
    vida24Benefits: [
      'Better organization and flow of medical procedures',
      'Improved communication between healthcare professionals and patients',
      'Secure and immediate access to health information'
    ],
    vida24Closing: 'With Vida24, we enable more accessible healthcare services—anytime, anywhere—with people at the center.',
    euroCollabTitle: 'Building new European collaborations',
    euroCollabDescription: 'Vidavo EU strengthens our presence in Europe through targeted partnerships, deployment of digital health technologies, and synergies with healthcare and technology organizations. The company is already expanding its network of collaborations in the European market.',
    euroCollabNote: 'Strategic partnership with FHC+P GmbH',
    getInTouchTitle: 'Get in touch with Vidavo EU',
    getInTouchDescription: 'Are you a healthcare organization, institution, or company interested in collaboration or international development opportunities?',
    getInTouchSubtext: 'Contact us to explore possibilities for projects, partnerships, or pilot implementations.',
    getInTouchCTA: 'Contact – Collaborate with Vidavo EU',
  },
  vidavo: {
    badge: 'COMPANY HISTORY',
    title: 'VIDAVO Through Time',
    subtitle: 'From our founding in 2002 to our global expansion today, explore the milestones that have shaped VIDAVO\'s journey in revolutionizing digital healthcare.',
    timeline: {
      event2025: 'Capital raised – Our partner ecosystem is being established around the globe',
      event2024: 'Vida24 InsurTech',
      event2023: 'AI enabled patient awareness and training',
      event2021: 'Vida24 Intelligent Triage Support System',
      event2020: 'Vida24 recognized among the top healthcare platforms worldwide',
      event2019: 'Expansion beyond EU',
      event2015: 'Patent: Interactive platform for Alzheimer Disease',
      event2014: 'Vida24 software certified as medical device',
      event2011: 'Patent: GPS panic button bracelet',
      event2010: 'Publicly listed at Euronext Athens Alternative Market (ΕΝ.Α. Growth), Capital raised through Private Placement',
      event2007: 'Patent: IoT medical device',
      event2005: 'Seed capital raised Thermi SA, Vida24 (Mobinet Wellness) commercial launch',
      event2002: 'Ltd Established by Dr. Pantelis Angelidis, Electrical Engineer',
    },
    buildingFuture: {
      title: 'Building the Future',
      description: 'Our journey continues as we push the boundaries of digital healthcare innovation, connecting patients and providers worldwide through advanced technology and compassionate care solutions.'
    }
  },
  whyUs: {
    badge: 'WHY CHOOSE US',
    title: 'Why Choose Us',
    subtitle: 'Discover what sets us apart in the digital health industry through our proven expertise, commitment to excellence, and unwavering dedication to innovation.',
    advantages: [
      {
        title: 'Expertise',
        description: 'Our team combines scientific knowledge, technical skills, and an entrepreneurial mindset to deliver high-quality services from implementation through to long-term support.'
      },
      {
        title: '25+ Years of Experience',
        description: 'We have been shaping digital health for over two decades, bringing research insights into real-world e/mHealth solutions.'
      },
      {
        title: 'Accreditations',
        description: 'Our operations follow internationally recognized standards for quality management, medical device safety, laboratory practice, anti-bribery compliance, and privacy information security, reflecting our commitment to building digital health solutions with the highest level of trust and reliability.'
      },
      {
        title: 'Certified Solutions',
        description: 'The Vida24 suite is CE Class IIa certified under MDD 93/42 EEC, meeting stringent European regulatory requirements.'
      },
      {
        title: 'Data Protection',
        description: 'We are registered with the Hellenic Data Protection Authority and fully compliant with GDPR, safeguarding sensitive personal health information.'
      },
      {
        title: 'Security',
        description: 'Our platforms are hosted on ISO 27001 compliant infrastructures, with redundant configurations for reliability and resilience.'
      }
    ],
    unGlobalCompact: {
      title: 'Commitment to Global Principles',
      description: 'We are a proud participant of the United Nations Global Compact, aligning our strategy and operations with its Ten Principles on human rights, labour, environment, and anti-corruption. This commitment reflects our dedication to responsible business practices and sustainable development, ensuring that our innovation contributes to positive global impact.',
      pillars: {
        humanRights: 'Human Rights',
        labour: 'Labour',
        environment: 'Environment',
        antiCorruption: 'Anti-Corruption'
      }
    },
    finalStatement: {
      title: 'Why trust us',
      description: 'Our solutions are certified, scientifically validated, extensively tested at scale, market-proven, and already operational across diverse business settings, trusted by a wide range of stakeholders.'
    }
  },
  scrollCarousel: {
    steps: {
      step1: {
        title: 'Your trusted Digital Health Expert',
        description: 'Evidence‑based digital health services with real‑world impact.',
      },
      step2: {
        title: 'Consulting',
        description: 'Discovery, needs assessment, and a clear digital‑health roadmap.',
      },
      step3: {
        title: 'Design',
        description: 'Human‑centered UX and clinical‑grade workflows.',
      },
      step4: {
        title: 'Develop / Integrate',
        description: 'Interoperable modules and secure integrations with existing systems.',
      },
      step5: {
        title: 'Customize / SaaS',
        description: 'Configurable features and scalable cloud delivery.',
      },
      step6: {
        title: 'Train',
        description: 'Practical training for clinicians, admins, and end users.',
      },
      step7: {
        title: 'Support',
        description: 'Ongoing SLA support, monitoring, and updates.',
      },
      step8: {
        title: 'Scale up',
        description: 'From pilot to production with governance and KPIs.',
      },
    },
  },
  collaboratorsCarousel: {
    title: 'Our Products',
    subtitle: 'Core VIDAVO solutions that form the backbone of our digital health ecosystem.',
    products: {
      vida24: 'Connected care dashboard',
      vida24Healthcare: '2nd opinion to GPs',
      vida24Monitoring: 'Patient health management',
      vidAware: 'Smartwatch integration',
      vidATrack: 'Emergency & location tracking',
      vida24Marine: 'Cruiseship telemedicine support',
      vida: 'Therapy support',
      vida24Vet: 'Veterinary health management',
    },
  },
  processFlow: {
    steps: {
      step1: {
        title: 'Consulting',
        description: 'We begin by understanding your needs, defining objectives, and shaping a clear digital health strategy.',
      },
      step2: {
        title: 'Design',
        description: 'We transform requirements into user-centered designs, ensuring usability, clinical safety, and compliance from the very beginning.',
      },
      step3: {
        title: 'Develop & Integrate',
        description: 'We build reliable digital health solutions and connect them with existing IT infrastructures, medical devices, and hospital systems.',
      },
      step4: {
        title: 'Customise / SaaS / White label',
        description: 'We deliver solutions as SaaS, offer white-label deployments for partners, or customise apps for specific workflows.',
      },
      step5: {
        title: 'Train',
        description: 'We provide training to healthcare professionals and staff, ensuring confident adoption and daily use of the new digital tools.',
      },
      step6: {
        title: 'Support',
        description: 'We offer ongoing technical support to keep systems reliable, secure, and continuously updated.',
      },
      step7: {
        title: 'Scale Up',
        description: 'We help expand pilots into large-scale deployments, adapting to new requirements and enabling sustainable growth.',
      },
    },
  },
  footer: {
    partnerText: 'We collaborate with partners and authorized resellers who share our vision for advancing digital health.',
    becomePartner: 'Become a partner',
    ourOffices: 'Our Offices',
    thessalonikiHQ: 'Thessaloniki HQ',
    thessalonikiAddress: '10th km Thessalonikis - N. Moudanion,',
    thessalonikiAddress2: 'Balkan Center, Building D, 57001',
    athens: 'Athens',
    athensAddress: 'Priinis 4, Nea Smyrni, 17122',
    ioannina: 'Ioannina',
    ioanninaAddress: 'Science and Technology Park of Epirus, 45500',
    vidavoEU: 'Vidavo EU – Liège, Belgium',
    vidavoEUAddress: 'Quai sur - Meuse 19, 4000 Liège, Belgium',
    callUsAt: 'Call us at',
    emailUsAt: 'Email us at',
    followUs: 'Follow us',
    copyright: '© 2025 VIDAVO.',
    allRightsReserved: 'All Rights Reserved.',
    personalData: 'Personal data',
    cookieNotice: 'Cookie notice',
    backToTop: 'Back to top',
    aboutVidavo: 'Learn more about Vidavo',
  },
  services: {
    hero: {
      title: 'Our Services',
      subtitle: 'Comprehensive digital health solutions spanning telemedicine, wellness, smart health systems, and strategic advisory services.',
    },
    categories: {
      telemedicine: {
        title: 'Telemedicine & Care Solutions',
        description: 'Remote care that connects patients and providers anytime, anywhere.',
        services: [
          {
            title: 'Chronic Disease Telemedicine',
            description: 'Remote monitoring and management of chronic conditions',
          },
          {
            title: 'Digital Outpatient Clinic',
            description: 'Virtual consultations and digital healthcare services',
          },
          {
            title: 'Emergency & Panic Button',
            description: 'Immediate emergency response and panic alert systems',
          },
          {
            title: 'Pregnancy Monitoring & Support',
            description: 'Comprehensive pregnancy care and monitoring solutions',
          },
          {
            title: 'Mental Health Support',
            description: 'Comprehensive mental health and psychological well-being services',
          },
          {
            title: 'Marine Telemedicine',
            description: 'Healthcare solutions for maritime and remote locations',
          },
        ],
      },
      wellness: {
        title: 'Wellness & Preventive Health',
        description: 'Tools and programs that support healthier lifestyles and early intervention.',
        services: [
          {
            title: 'Behavioural Change Solutions',
            description: 'Evidence-based programs for sustainable lifestyle changes',
          },
          {
            title: 'Corporate Wellbeing',
            description: 'Employee wellness programs and occupational health solutions',
          },
          {
            title: 'Scientific Wellness',
            description: 'Research-backed wellness interventions and protocols',
          },
          {
            title: 'eHealth & Wellness Tourism',
            description: 'Digital health solutions for wellness travel and tourism',
          },
        ],
      },
      smartHealth: {
        title: 'Next-Gen HealthTech',
        description: 'Smart technologies transforming data into actionable health insights.',
        services: [
          {
            title: 'InsurTech',
            description: 'Insurance technology solutions for healthcare coverage',
          },
          {
            title: 'Digital Therapeutics & Pharma',
            description: 'Evidence-based therapeutic interventions via digital platforms',
          },
          {
            title: 'Digital Animal Health',
            description: 'Veterinary telemedicine and animal health monitoring',
          },
          {
            title: 'Eco-Health Analytics',
            description: 'Environmental health monitoring and analytics solutions',
          },
          {
            title: 'AI Decision Support',
            description: 'Artificial intelligence for clinical decision making',
          },
          {
            title: 'DRG decision support',
            description: 'Diagnosis-Related Groups classification and optimization systems',
          },
        ],
      },
      advisory: {
        title: 'Strategy & Advisory',
        description: 'Expert guidance to design, implement, and scale digital health initiatives.',
        services: [
          {
            title: 'Digital Health Consulting',
            description: 'Strategic consulting for healthcare digital transformation',
          },
        ],
      },
    },
    servicesAvailable: 'Services Available',
    cta: {
      title: 'Ready to Transform Healthcare?',
      description: 'Discover how our comprehensive digital health solutions can revolutionize your healthcare delivery and improve patient outcomes.',
      scheduleConsultation: 'Schedule Consultation',
    },
  },
  chronicConditionManagement: {
    title: 'Chronic Condition Management',
    subtitle: 'Comprehensive digital solutions for managing chronic health conditions with continuous monitoring and personalized care plans.',
    ourApproach: {
      title: 'Our Approach',
      description: 'We provide integrated healthcare solutions that help patients and healthcare providers manage chronic conditions more effectively through advanced technology and personalized care protocols.',
    },
    keyFeatures: {
      title: 'Key Features',
      features: [
        'Real-time health monitoring and alerts',
        'Personalized treatment plans',
        'Medication management and reminders',
        'Regular health assessments',
        'Healthcare provider coordination',
        'Patient education and support resources',
      ],
    },
    conditionsWeSupport: {
      title: 'Conditions We Support',
      description: 'Our platform supports management of various chronic conditions including diabetes, hypertension, heart disease, COPD, and other long-term health conditions requiring ongoing care and monitoring.',
    },
  },
  serviceModal: {
    title: 'Service Details',
    description: 'Detailed information about the selected service including media, description and features.',
    altTexts: {
      mobileHealthApp: 'Mobile health monitoring app showing oximetry readings and activity tracking',
      insurtechDashboard: 'InsurTech dashboard showing insurance analytics and management',
      ecoHealthDashboard: 'Eco-Health Analytics dashboard showing environmental and health data correlations',
      digitalAnimalHealth: 'Digital Animal Health platform showing veterinary dashboard and request management',
      aiDecisionSupport: 'AI Decision Support mobile app showing contactless vital signs scanning and health analytics',
      digitalHealthConsulting: 'Digital Health Consulting strategy roadmap showing goals, standards, and outcomes',
      scientificWellness: 'Scientific Wellness mobile app showing sleep and heart rate monitoring with data visualization',
      ehealthWellnessTourism: 'eHealth & Wellness Tourism mobile app showing exercise mode with running timer and progress tracking',
    },
    specificDescriptions: {
      insurtech: 'Digital transformation is reshaping insurance, shifting the focus from claims management to proactive health and long-term customer value.',
      ecoHealth: 'Environmental conditions shape human health. Eco-Health analytics uncovers these links by combining environmental and clinical information to reveal patterns, predict risks, and guide smarter decisions for cities and industry.',
      aiDecisionSupport: 'Artificial intelligence steps in as a clinical partner. From a quick camera scan of vital signs to predictions that guide care, it transforms raw data into actionable support for doctors and patients alike.',
      digitalHealthConsulting: 'Healthcare organizations, municipalities, and insurers are under pressure to modernize with digital tools, yet the complexity of regulations, interoperability, and change management makes this challenging. Our consulting services help navigate this transition with clarity and strategy.',
      scientificWellness: 'Prevention enters the era of precision. Scientific wellness integrates genetic data, biomarkers, and digital health metrics to create individualized wellness strategies rooted in science.',
      ehealthWellnessTourism: 'Tourism and health intersect in new ways. eHealth and wellness tourism combines preventive check-ups and wellness programs with travel experiences, offering visitors long-term digital follow-up after their stay.',
    },
  },
  serviceData: {
    chronicDiseaseTelemedicine: {
      description: 'Digital tools for continuous management of chronic diseases, enabling patients to live healthier lives while healthcare professionals can monitor, intervene, and adapt care remotely.',
      features: [
        { title: 'Health record', description: 'Personalized medical file with profile, history, biological signal recordings, medication, and more.' },
        { title: 'Telemetry', description: 'Wireless monitoring of vital signs with real-time cloud transmission' },
        { title: 'Alerts & notifications', description: 'Personalised alerts, reminders, and notifications for patients and clinicians' },
        { title: 'Tailored digital environments', description: 'Dedicated mobile app, web platform, and dashboards for patients and healthcare professionals' },
        { title: 'Care plan management', description: 'Structured care plans covering medication adherence, activity goals, and follow-up scheduling' },
        { title: 'Remote consultations', description: 'Audio/video communication, chat, secure file sharing, and online consultation' },
      ],
    },
    digitalOutpatientClinic: {
      description: 'The Digital Outpatient Clinic transforms routine visits and follow-ups into secure, convenient online interactions. Patients connect with their doctors from anywhere, while clinicians manage appointments, records, and care plans on a single platform.',
      features: [
        { title: 'Remote consultations', description: 'Chat, video, and secure messaging for direct patient–doctor communication.' },
        { title: 'Scheduling & management', description: 'Integrated calendar for booking, reminders, and follow-up visits.' },
        { title: 'Integrated health data', description: 'Brings together health records, questionnaires, and medical files in one place.' },
        { title: 'Customisable environments', description: 'Flexible workflows tailored to different specialties (e.g. cardiology, endocrinology, dermatology).' },
        { title: 'e-Prescriptions & medication management', description: 'Enables doctors to issue prescriptions digitally.' },
        { title: 'Billing support', description: 'Optional module for handling patient payments.' },
      ],
    },
    emergencyPanicButton: {
      description: 'Immediate access to help in urgent situations. With a single press, patients can alert caregivers, clinicians, or emergency services, ensuring rapid response when it matters most.',
      features: [
        { title: 'One-touch alert', description: 'Instant call for help through dedicated panic button.' },
        { title: 'Real-time location', description: 'GPS tracking to guide caregivers or emergency responders to the user\'s position.' },
        { title: 'Geo-zones & notifications', description: 'Configurable safety zones; alerts are sent if the wearer moves outside predefined limits.' },
        { title: 'Fall detection', description: 'Automatic detection of falls and alert transmission, even if the user cannot press the button.' },
        { title: 'Integrated communication', description: 'Direct voice or video connection with clinicians, call centers, or family members.' },
        { title: 'Custom escalation paths', description: 'Configurable workflows defining who is notified first (family, caregiver, emergency team).' },
      ],
    },
    mentalHealthSupport: {
      description: 'Accessible digital services that complement clinical, enabling continuous assessment, structured interventions, and improved patient engagement.',
      features: [
        { title: 'Clinical assessment tools', description: 'Standardized questionnaires for depression, anxiety, and mood tracking.' },
        { title: 'Remote counselling', description: 'Secure chat or video sessions with psychologists, psychiatrists, or certified coaches.' },
        { title: 'Educational resources', description: 'Scientifically validated resources and psychoeducational content to support adherence and self-management.' },
        { title: 'Risk management', description: 'Configurable alerts for crisis situations, ensuring timely escalation to clinicians or caregivers.' },
        { title: 'Treatment planning', description: 'Tools for clinicians to set therapy goals, assign digital exercises, and monitor adherence.' },
        { title: 'Progress tracking', description: 'Longitudinal monitoring of symptom progression and treatment response through structured dashboards.' },
      ],
    },
    pregnancyMonitoring: {
      description: 'Digital health solutions that accompany mothers through every stage of pregnancy, combining monitoring, education, and expert access for safer and more confident journeys.',
      features: [
        { title: 'Connected devices & wearables', description: 'Track vital signs (blood pressure, heart rate, glucose, weight) and fetal well-being with medical-grade devices.' },
        { title: 'Educational resources', description: 'Access to evidence-based content, tips, and guidelines tailored to each stage of pregnancy.' },
        { title: 'Expert connection', description: 'Direct communication with gynecologists, midwives, or other specialists for reassurance and timely guidance.' },
        { title: 'Care plan & reminders', description: 'Personalized schedules for check-ups, tests, nutrition, exercise, and medication adherence.' },
        { title: 'Digital diary', description: 'Mothers can log daily symptoms, moods, and lifestyle habits for more complete care insights.' },
      ],
    },
    marineTelemedicine: {
      description: 'Healthcare at sea is challenging due to distance, limited resources, and intermittent connectivity. Marine telemedicine bridges this gap by equipping ships with tools for first-line care',
      features: [
        { title: 'Crew-initiated care', description: 'Designated officers act as first responders, supported by remote specialists.' },
        { title: 'Offline-first design', description: 'Medical data are recorded during the incident and synchronized with experts once internet access is restored.' },
        { title: 'Connected medical devices', description: 'On-board diagnostic tools (ECG, oximeter, blood pressure monitors) capture vital signs for remote review.' },
        { title: 'Image & file exchange', description: 'Photos, scans, or other documents can be shared with specialists to support accurate evaluation.' },
        { title: 'Remote consultations', description: 'Video or messaging with on-shore doctors for triage, acute care, or chronic condition management.' },
        { title: 'Logistics integration', description: 'Coordination with ports, clinics, and evacuation services when on-site care is required.' },
      ],
    },
    behaviouralChangeSolutions: {
      description: 'Changing habits is at the heart of prevention. Behavioural change solutions combine digital tools with evidence-based methods to motivate healthier lifestyles and support long-term adherence.',
      features: [
        { title: 'Personalized programs', description: 'Tailored plans for nutrition, activity, and lifestyle change based on individual needs.' },
        { title: 'Goal setting and reminders', description: 'Structured objectives with smart notifications that keep users engaged and on track.' },
        { title: 'Daily monitoring', description: 'Daily tracking of steps, activity, weight, and other key wellness indicators.' },
        { title: 'Motivational feedback', description: 'Encouragement and real-time insights that sustain long-term progress.' },
        { title: 'Educational content', description: 'Evidence based resources that explain the science behind healthy choices.' },
        { title: 'Progress visualization', description: 'Clear charts and dashboards that highlight milestones and overall improvement.' },
      ],
    },
    corporateWellbeing: {
      description: 'Healthy workplaces create stronger businesses. Corporate wellbeing programs improve employee health, reduce absenteeism, and build a culture of engagement and resilience.',
      features: [
        { title: 'Branded platforms', description: 'Employer branded platforms that promote wellbeing across the workforce.' },
        { title: 'Health programs', description: 'Programs supporting stress management, physical activity, and mental health.' },
        { title: 'Engagement tools', description: 'Digital tools that encourage participation through reminders and gamification.' },
        { title: 'Lifestyle resources', description: 'Access to resources for healthier nutrition and lifestyle choices.' },
        { title: 'Workforce analytics', description: 'Analytics that help HR track participation, outcomes, and return on investment.' },
        { title: 'Policy integration', description: 'Alignment with occupational health and safety policies already in place.' },
      ],
    },
    scientificWellness: {
      description: 'Prevention enters the era of precision. Scientific wellness integrates genetic data, biomarkers, and digital health metrics to create individualized wellness strategies rooted in science.',
      features: [
        { title: 'Comprehensive profiling', description: 'Collection of genetic, biomarker, and lifestyle data to build each individual\'s health profile.' },
        { title: 'Personalised planning', description: 'Wellness strategies built on scientific evidence and measurable goals.' },
        { title: 'Continuous monitoring', description: 'Real-time tracking of biological signals such as stress, heart rate variability, and metabolic markers.' },
        { title: 'Adaptive recommendations', description: 'Feedback loops that adjust recommendations as new data is collected.' },
        { title: 'Scientific resources', description: 'Educational material that explains the science behind each recommendation.' },
        { title: 'Insights', description: 'Visual dashboards that show progress and highlight emerging health trends.' },
      ],
    },
    ehealthWellnessTourism: {
      description: 'Tourism and health intersect in new ways. eHealth and wellness tourism combines preventive check-ups and wellness programs with travel experiences, offering visitors long-term digital follow-up after their stay.',
      features: [
        { title: 'Preventive assessments', description: 'On-site preventive health assessments integrated into wellness travel packages.' },
        { title: 'Personalised nutrition', description: 'Hotels and resorts that adapt meal options to the visitor\'s health profile and wellness goals.' },
        { title: 'Wellness plans', description: 'Personalized wellness plans that combine medical advice with lifestyle coaching.' },
        { title: 'Cultural integration', description: 'Programs that merge local culture, nature, and wellness practices for holistic experiences.' },
        { title: 'Continuity of care', description: 'Data integration that ensures continuity of care between tourist services and health providers.' },
        { title: 'Wellness dashboards', description: 'Digital records and dashboards that help visitors track their wellness journey over time.' },
      ],
    },
    insurtech: {
      description: 'Digital transformation is reshaping insurance, shifting the focus from claims management to proactive health and long-term customer value.',
      features: [
        { title: 'Teleconsultations', description: 'Online medical sessions included in insurance packages, improving access and lowering costs.' },
        { title: 'Tele-underwriting', description: 'Remote health assessment for faster, more accurate risk stratification and approval of insurance policies.' },
        { title: 'Personalized care', description: 'Focus on prevention, early diagnosis, and remote monitoring to reduce claims and improve outcomes.' },
        { title: 'Customer experience', description: 'Branded or white-label mobile apps that enhance accessibility, loyalty, and user satisfaction.' },
        { title: 'Data-driven risk management', description: 'Advanced analytics that improve underwriting accuracy, forecast costs, and support smarter product design.' },
        { title: 'New business models', description: 'Enable insurers to design preventive, value-based products that expand service offerings and competitiveness.' },
      ],
    },
    digitalTherapeuticsPharma: {
      description: 'When medicine leaves the box, it becomes digital. We provide software interventions and companion apps that extend treatment, improve adherence, and generate real-world evidence.',
      features: [
        { title: 'Companion apps for drugs', description: 'Branded or white-label applications that guide patients in medication use, provide reminders, and deliver tailored educational content.' },
        { title: 'Evidence-based digital therapeutics', description: 'Clinically validated apps and interventions addressing specific conditions such as diabetes, insomnia, or depression.' },
        { title: 'Medication adherence support', description: 'Pill reminders, digital diaries, and connected devices that reinforce treatment compliance.' },
        { title: 'Clinical trial support (eCRF modules)', description: 'Electronic case report forms with integrated questionnaires, symptom tracking, and digital monitoring, designed to simplify trial data collection.' },
        { title: 'Analytics & reporting', description: 'Automated analysis of patient-reported outcomes and clinical data, generating regulatory-ready reports.' },
        { title: 'Patient engagement', description: 'Interactive features that motivate patients through feedback, progress tracking, and communication with trial coordinators or care teams.' },
      ],
    },
    digitalAnimalHealth: {
      description: 'From pets at home to herds in the field, digital tools are transforming veterinary care. Our solutions bring monitoring, records, and expert guidance into one connected environment.',
      features: [
        { title: 'Tele-veterinary consultations', description: 'Book and manage veterinary appointments online, for check-ups, follow-up, and urgent situations.' },
        { title: 'Digital health records', description: 'Comprehensive animal profiles including vaccination schedules, treatments, nutrition, and diagnostics.' },
        { title: 'Remote guidance for care', description: 'Digital instructions and follow-up plans for nutrition, recovery, and preventive routines after veterinary visits.' },
        { title: 'Population-level monitoring', description: 'Analytics for livestock herds, shelters and breeding programs, supporting disease prevention and welfare management.' },
        { title: 'Integration with veterinary pharma', description: 'Companion apps linked with treatments to support adherence and track outcomes.' },
        { title: 'Data analytics and reporting', description: 'Early warning systems for disease outbreaks, performance tracking, and optimized care strategies.' },
      ],
    },
    ecoHealthAnalytics: {
      description: 'Environmental conditions shape human health. Eco-Health analytics uncovers these links by combining environmental and clinical information to reveal patterns, predict risks, and guide smarter decisions for cities and industry.',
      features: [
        { title: 'Public datasets', description: 'Import and process datasets from established environmental indicator databases.' },
        { title: 'Environmental data feeds', description: 'Data streams import from environmental sensors measuring air quality, pollutants or climate indicators from sensor networks and open APIs to enrich health analytics.' },
        { title: 'Health–environment correlation', description: 'Analysis of combined datasets to identify patterns, trends, and risk factors that link environmental exposures with health outcomes' },
        { title: 'Trend analysis and alerts', description: 'Monitoring of long-term exposure levels and automatic alerts for high-risk events such as heatwaves or pollution peaks.' },
        { title: 'Decision support for cities and industry', description: 'Provide evidence-based insights to guide urban planning, occupational health, and corporate sustainability strategies.' },
        { title: 'Visualisation and dashboards', description: 'Interactive maps and dashboards that display environmental indicators alongside health outcomes for easier interpretation.' },
      ],
    },
    aiDecisionSupport: {
      description: 'Intelligent clinical assistance powered by advanced AI to enhance decision-making, streamline workflows, and improve patient outcomes.',
      features: [
        { title: 'AI chart review', description: 'Retrieves and summarizes relevant items from the patient profile so doctors can scan exams, history, medications, and notes quickly.' },
        { title: 'Contactless vital signs', description: 'Measure heart rate and wellness indicators through the phone camera using advanced rPPG technology. In just one short scan, patients get insights as easily as taking a selfie.' },
        { title: 'Risk assessment and prediction', description: 'Questionnaire based scoring and AI models, paired with tailored lifestyle advice.' },
        { title: 'Symptom checker', description: 'Patient entered symptoms evaluated by AI with suggested actions and guidance on when to seek care.' },
        { title: 'Clinical decision support', description: 'Models that flag deterioration risk, propose next steps, and support preventive and personalized interventions.' },
        { title: 'Business intelligence', description: 'Dashboards that analyze activity across facilities to optimize staffing, discharge planning, and follow up while tracking readmissions and costs.' },
      ],
    },
    drgDecisionSupport: {
      description: 'Diagnosis-Related Groups (DRGs) are more than a reimbursement tool. Used effectively, they become a decision support mechanism that improves cost control, transparency, and trust across insurers, providers, and patients, while also supporting hospitals in accurate coding and auditing.',
      features: [
        { title: 'Cost optimization', description: 'Standardized costing of medical cases by diagnosis and clinical severity reduces variability and makes healthcare expenses more predictable.' },
        { title: 'Transparent pricing', description: 'Supports insurers, providers, and patients with reliable, comparable costing models that strengthen trust and competitiveness.' },
        { title: 'Risk assessment for insurance', description: 'Improves risk estimation for both group and individual health plans, helping design sustainable insurance products.' },
        { title: 'Hospital coding support', description: 'Assists clinicians and coders with correct and consistent recording of cases based on ICD and GPC classifications.' },
        { title: 'Audit and quality control', description: 'Automated audit mechanisms identify weaknesses in medical record coding and support early corrective action.' },
        { title: 'Targeted improvements', description: 'Audit results guide interventions such as staff training, updates to operational guidelines, and coding refinements.' },
      ],
    },
    digitalHealthConsulting: {
      description: 'Strategic consulting and expert guidance for healthcare organizations navigating digital transformation and innovation.',
      features: [
        { title: 'Digital health strategy', description: 'Development of roadmaps for hospitals, municipalities, and insurers to adopt and scale digital solutions.' },
        { title: 'Interoperability and integration', description: 'Guidance on standards such as HL7 FHIR, DICOM, and openEHR to ensure systems communicate securely and effectively.' },
        { title: 'Process redesign', description: 'Support in restructuring clinical and administrative workflows to align with digital transformation goals.' },
        { title: 'Regulatory compliance', description: 'Expertise on MDR, GDPR, and national frameworks to ensure projects meet legal and ethical requirements.' },
        { title: 'Capacity building', description: 'Training and support programs for clinicians, administrators, and technical teams.' },
        { title: 'Evaluation and KPIs', description: 'Design of monitoring frameworks with measurable indicators for performance, efficiency, and impact.' },
      ],
    },
  },
  investorRelations: {
    title: "Investor Relations",
    description: "VIDAVO, founded in 2002, headquartered in Thessaloniki, Greece and has offices in Athens. It's listed on the Alternative Market (ΕΝ.Α. Growth) of Euronext Athens (OASIS: BINTA).",
    stockExchange: {
      title: "Stock exchange releases",
      ticker: "OASIS Ticker",
      description: "A detailed overview of past and today's market information stock, which is identified by the ticker symbol",
      issuersCorner: "Issuers corner",
      stockInfo: "Stock info"
    },
    keyMetrics: {
      revenueGrowth: {
        label: "Revenue Growth",
        value: "45%",
        description: "Year-over-year growth"
      },
      marketPenetration: {
        label: "Market Penetration",
        value: "15+",
        description: "Countries served"
      },
      healthcarePartners: {
        label: "Healthcare Partners",
        value: "250+",
        description: "Active partnerships"
      },
      patientLives: {
        label: "Patient Lives Impacted",
        value: "1M+",
        description: "Through our platforms"
      }
    },
    documents: {
      title: "Investor Documents",
      download: "Download",
    categories: {
      financial: "Annual Reports",
      governance: "1st Semester Reports",
      presentations: "Balance Sheet",
      regulatory: "Announcements",
      assemblies: "General Assemblies"
    },
    names: {
      annualReport: "annual report",
      firstSemester: "1st Semester",
      balanceSheet: "Balance sheet",
      balanceSheetFirstSemester: "Balance sheet (1st semester)",
      announcement: "Announcement",
      generalMeeting: "GM",
      corporatePresentation: "Annual corporate presentation"
    }
  },
    contact: {
      title: "Investor Relations Contact",
      description: "For investment opportunities, financial information, or investor inquiries, please contact our team",
    sendEmail: "Send email"
  }
},

careers: {
  title: "Careers at VIDAVO",
  subtitle: "Join our mission to transform healthcare through innovative technology. Build your career while making a meaningful impact on global health outcomes.",
  whyWorkAtVidavo: {
    title: "Why Work at VIDAVO",
    description: "At VIDAVO, you'll be part of a dynamic team that's revolutionizing healthcare delivery. We offer a collaborative environment where innovation thrives, and every team member contributes to improving lives through technology.",
    culture: {
      title: "Our Culture",
      description: "We foster a culture of innovation, collaboration, and continuous learning. Our team is passionate about healthcare technology and committed to making a positive impact on patient outcomes worldwide.",
      values: {
        innovation: "Innovation-driven environment",
        learning: "Continuous learning opportunities",
        collaboration: "Collaborative team culture",
        impact: "Meaningful healthcare impact"
      }
    }
  },
  noOpenPositions: {
    description: "We are always excited to meet people who share our philosophy and could see themselves growing with us. For current job opportunities, please visit our",
    linkedIn: "LinkedIn",
    descriptionEnd: "page. If you believe your mindset and skills align with our work, we'd love to hear from you.",
    sendEmail: "Send email"
  }
},
personalData: {
  badge: "GDPR DATA PROTECTION",
  title: "Privacy Policy & Data Protection",
  description: "We thank you for visiting the website of VIDAVO and assure you that the protection of your personal data is our utmost priority.",
  sections: {
    usefulDefinitions: "Useful Definitions",
    dataController: "Data Controller",
    whatDataWeProcess: "What Data We Process",
    informationRegardingCookies: "Information Regarding Cookies",
    yourRights: "Your Rights and How You Can Exercise Them",
    periodOfStorage: "Period of Storage of Data",
    informationSecurityPolicy: "Information Security Policy",
    purposesAndLegalBasis: "Purposes and legal basis for processing your data",
    thirdPartyLinks: "Links of third parties' websites",
    revisions: "Revisions",
    antiBriberyPolicy: "Anti-bribery policy"
  },
  usefulDefinitionsContent: {
    intro: "For your better information, we use the following terms which are defined as set out below:",
    personalData: 'a) "Personal data": is information relating to an individual. Data is considered personal, if the person they concern can be identified, directly or indirectly (i.e. either by mentioning the name, ID number, home address and other contact details (telephone number e-mails), IP address of the device used to "go" online, age, sex, external features, family situation, level of education, occupation, interests etc). The natural person to which the personal data refer is called "data subject".',
    sensitiveData: 'b) "Special categories of personal data" (or "sensitive data"): are data relating to the intimate sphere of the individual (e.g. health, religious believes, political views, trade union-related activities, racial origin, sex life).',
    dataProcessing: 'c) "Data processing": is any activity involving personal data, irrespective of the means applied (i.e. automated or manual) such as the collection, filing, organisation, structure, storage, adjustment or alteration, retrieval, search of information, use, disclosure by transmission, dissemination or any other form of disposal, association or combination, limitation, deletion or destruction.',
    legislation: 'd) "Legislation": the Greek and European legislation on the protection of natural persons with regard to the processing of personal data, including the General Data Protection Regulation 2016/79 (GDPR).',
    dataLogs: 'e) "Data logs": electronic files regarding movement on the website which are recorded on our server.',
    cookies: 'f) "Cookies": Small files of data in the form of a text which are stored on your electronic device (computer, mobile, tablet) when you visit the Website and which provide',
    specificInformation: "specific information",
    cookiesEnd: "regarding your movements on the website."
  },
  dataControllerContent: {
    paragraph1: "Data controller: The data controller according to art. 4 para. 7 of the General Data Protection Regulation (GDPR) is VIDAVO AE, BALKAN CENTER, 10 km Thessaloniki-N. Moudania, 57001 Thermi, vidavo@vidavo.eu.",
    paragraph2: 'You can contact the data controller at the following address dpo@vidavo.eu or at the postal address with the note "for the attention of the data controller".'
  },
  whatDataWeProcessContent: {
    sectionA: "A) Data which are logged automatically on our server",
    dataLogs: "(1) Data logs",
    dataLogsIntro: "When you enter our Website we collect those personal data (data logs) which are transmitted to our server by your browser and specifically:",
    dataLogsList: [
      "IP- Address",
      "Date and time of your entry",
      "Time difference with Greenwich Mean Time - GMT",
      "Content of the request (specific page)",
      "Statuscode-HTTP",
      "Every quantity of data transmitted",
      "Webpage, from which the request comes from",
      "Browser",
      "Operating system",
      "Language and edition of browser software"
    ],
    cookiesSubtitle: "(2) Cookies",
    cookiesText: 'In addition to the above-mentioned data, when you use the Website, cookies are stored on your pc i.e. small data files (text files) which are stored on the device you use and transmit identification data in respect of your device to our server i.e. a unique identification number is created. It should be noted that with the exception of "session cookies", which are absolutely necessary for your unhindered access and use of our Website, all other cookies are stored on our server only provided that you have provided your consent and you activate them when you enter our website.',
    sectionB: "B) Data which you enter",
    sectionBText: 'When you communicate via e-mail, we store the data you provide (your e-mail, possibly your name and telephone number) in order to respond to your queries. In this context, when the storage is no longer necessary, we delete the data in question or we reduce their processing, in the event that there is no legal obligation to retain the data. You may ask us at any time to stop using your e-mail address and to refrain from any further information/communication, by exercising the "right to object" as provided for by the relevant legislation.'
  },
  cookiesInfoContent: {
    intro: "Our website uses cookies to enhance your browsing experience, provide essential functionality, and analyze website usage. Below you'll find detailed information about the cookies we use:",
    essentialTitle: "Essential Cookies",
    essentialText: "These cookies are necessary for the website to function properly and cannot be disabled. They are usually set in response to actions you take, such as setting your privacy preferences, logging in, or filling out forms.",
    analyticsTitle: "Analytics Cookies",
    analyticsText: "These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website's performance and user experience.",
    tableHeaders: {
      cookieName: "Cookie Name",
      category: "Category",
      purpose: "Purpose",
      duration: "Duration"
    },
    tableData: [
      {
        name: "cookie-consent",
        category: "Essential",
        purpose: "Stores your cookie consent preferences to remember your choices about which cookies you accept.",
        duration: "1 year"
      },
      {
        name: "session-id",
        category: "Essential",
        purpose: "Maintains your session state while browsing the website to ensure proper functionality.",
        duration: "Session only"
      },
      {
        name: "_ga",
        category: "Analytics",
        purpose: "Google Analytics cookie that distinguishes unique users and provides insights into website usage patterns.",
        duration: "2 years"
      },
      {
        name: "_ga_*",
        category: "Analytics",
        purpose: "Google Analytics 4 cookie that collects information about how you interact with our website.",
        duration: "2 years"
      }
    ],
    managingTitle: "Managing Your Cookie Preferences",
    managingText: 'You can manage your cookie preferences at any time by clicking the "Cookie Settings" link in our website footer or by using your browser\'s settings to block or delete cookies. Please note that disabling essential cookies may affect the functionality of our website.'
  },
  yourRightsContent: {
    intro: "You can at any time exercise the following rights which are provided for by the GDPR:",
    rights: [
      'Right to know which of your personal data are being processed via our platform and in which way, right to obtain copies of these data, as well as any other information regarding the processing ("right of information and access").',
      "Right to rectification i.e. right to request correction and/or completion of incorrect or incomplete data for example if you change your e-mail address you request that we substitute it with the new address.",
      "Right to request data erasure ('right to be forgotten') and/or right to restriction of processing, if it is no longer necessary or if it is not done in line with the law or if the deletion is obligatory by law.",
      "Right to restrict processing, i.e. right to request that the processing is restricted for such time as your request for correction or deletion is pending.",
      "Right to data portability, that is, the right to ask to receive your data in readable electronic format and request transmission of those data by us to third parties which you will indicate.",
      "Right to object to the processing of your personal data."
    ],
    contactTitle: "Contact Information",
    contactText1: "In order to exercise your above rights and for any communication regarding your personal data, you can communicate via e-mail at dpo@vidavo.eu, Att. of Paraskevi Katsouli or via phone at +302310474762.",
    contactText2: "Additionally, should you feel that your personal data are in any way compromised, you have the right to lodge a complaint with the Data Protection Authority (1-3 Kifissias Av., 11523 Athens, 210 6475600, contact@dpa.gr)."
  },
  purposesAndLegalBasisContent: {
    paragraph1: "The purpose for recording the IP address and for processing the data from the File Records and the Obligatory Cookie is the function of our Website as well as dealing with possible technical problems and protecting our Website from potential malicious or illegal use (e.g. via the record of IP addresses). The legal basis for the above processing is our legitimate interest to protect the security and integrity of our Website.",
    paragraph2: "The processing of the data from the Voluntary Cookies aims at handling, analyzing and updating the Website through the extraction and analysis of statistical data which refer to the number of our visitors, the number of times each visitor visits us, their geographical origin, the language they prefer seeing on our Website, which pages they visit more often with a view to assess the user's behavior (e.g. for the purpose of behavioral advertisement). The processing in question is based on your consent i.e. the activation of each cookie when you enter our Website, which you can withdraw at any time in the same manner, by deactivating the cookies you wish."
  },
  thirdPartyLinksContent: "The Website refers to third parties' websites which may perform further processing of the data of their visitors/users, use different cookies etc. Vidavo bears no responsibility regarding those websites and for any relevant matter you will have to contact the relevant owners.",
  revisionsContent: "Prior to any potential change of processing of personal data via the Website, we will amend the present Policy accordingly and will display it in order for you to receive the relevant information and be able to exercise your rights effectively.",
  periodOfStorageContent: {
    ipAddress: "The IP address of your device (pc, mobile or tablet) which is stored automatically on our server when you enter our website is stored for three months from when you enter the website and is deleted automatically thereafter.",
    sessionCookies: "The Session-Cookies are deleted when you go off-line or you close your browser. As regards \"optional\" cookies, those are stored for the period of time mentioned in the above Table.",
    emailData: "Data which you provide us with in order to contact us via e-mail (your e-mail, possibly your name and telephone number), are stored for as long as necessary, in order for us to respond to your queries and if the storage is no longer necessary, we delete the data or reduce their processing, provided that we are not obliged to retain the data by law.",
    claimsData: "In the event that a claim is lodged (in or out of court), the data will be retained until the final and unappealable resolution of the claims or until they become time-barred."
  },
  informationSecurityPolicyContent: {
    intro: "VIDAVO S.A., responding to the requirements of modern business reality and aiming at the protection of the information it manages, always aiming at the uninterrupted and exemplary service to its Clients through the maintenance of confidentiality, availability and integrity of information, decided to design and install an Information Security Management System in accordance with the requirements of the International Standard ISO 27001:2022.",
    coversTitle: "The Company's Information Security Management System covers:",
    coversList: [
      "Design, development and production of software for receiving, processing and transmitting medical signals and information",
      "Training in the use of software for receiving, processing and transmitting medical signals and information",
      "Technical support of software for receiving, processing and transmitting medical signals and information",
      "Distribution of medical devices for monitoring and measuring physiological parameters, and their consumables"
    ],
    objectivesTitle: "Main Objectives:",
    objectivesList: [
      "To ensure the confidentiality, integrity and availability of the information managed, including personal data",
      "Ensuring the proper functioning of the information systems",
      "The timely response to incidents that may jeopardize its business operations",
      "Meeting legislative and regulatory requirements",
      "The continuous improvement of the level of Information Security"
    ],
    managingDirector: "Managing Director",
    name: "Markella Psymarnou",
    date: "Thessaloniki, 13/09/2024"
  },
  antiBriberyPolicyContent: {
    policySummary: {
      title: "Policy Summary",
      intro: "VIDAVO S.A. is committed to conducting its business in accordance with the highest ethical standards and prohibits all forms of bribery and corruption. This Anti-Bribery Policy prohibits the bribery of government officials as well as private sector bribery, including the offer, promise, authorization or provision of anything of value to any customer, business partner, vendor or other third party in order to induce or reward improper performance of an activity related to our business. Violation of this Policy could result in disciplinary action, including, but not limited to, termination of employment. It is crucial that you not only understand and appreciate the importance of this Policy, but that you comply with it in your daily work. If you have any questions about this Policy or applicable anti-bribery laws in general, please contact the Anti-Bribery System Manager at compliance@vidavo.eu.",
      conjunction: "In conjunction with this Policy, please refer to the Anti-Bribery Procedure Documents for additional information and details."
    },
    purposeAndObjectives: {
      title: "Purpose and objectives of the policy",
      content: "This Policy is intended to describe the Company's risks related to bribery and corruption, to highlight your responsibilities under relevant anti-corruption laws and Company policies, and to provide you with the tools and support necessary to identify and combat these anti-corruption risks."
    },
    risksAndConsequences: {
      title: "Risks and/or consequences of non-compliance",
      content: "Violation of relevant anti-corruption laws may result in severe civil and criminal penalties and damage to our Company's reputation. Company employees who violate these laws may also face severe civil and criminal penalties, including jail time. A violation of this Policy could result in disciplinary action, including, but not limited to, termination of employment."
    },
    scopeAndRange: {
      title: "Scope and range of application",
      content: "The Company expects all employees, officers, directors and third parties working on its behalf to refrain from any form of bribery or corruption, regardless of nationality, residence or location. In addition to this general prohibition against bribery and corruption, this Policy and Procedure Documents set out several policy and procedural requirements that apply to all its employees."
    },
    policyDetails: {
      title: "Policy details",
      applicableLaws: {
        title: "4.1 Applicable laws",
        content: "Company employees must comply with all applicable anti-bribery laws. Such laws generally prohibit both bribery of government officials and private sector bribery."
      },
      prohibitionOfBribery: {
        title: "4.2 Prohibition of bribery",
        governmentBribery: {
          title: "4.2.1 Government bribery",
          content: "The Company and its employees are prohibited from giving, promising, offering or authorizing payment of anything of value to any government official to obtain or retain business, secure any other improper advantage, or improperly influence the actions of a government official. In addition, Company associates should also avoid inappropriate interactions with government officials."
        },
        commercialBribery: {
          title: "4.2.2 Commercial Bribery",
          content: "In addition to the prohibitions on bribery of government officials discussed above, the Company prohibits employees from offering or providing payments and other benefits to or accepting the same from private persons and entities. Such payments constitute commercial bribery and are often referred to as \"kickbacks.\""
        },
        facilitationPayments: {
          title: "4.2.3 Facilitation payments",
          content: "The Company's prohibition on bribery applies to all improper payments regardless of size or purpose, including \"facilitating\" (or expediting) payments. Facilitation payments refer to small payments to government officials to expedite or facilitate actions or services, such as obtaining a license, processing government documents such as visas, clearing customs, providing telephone, electricity or water service, or loading or unloading cargo. Generally, facilitation payments are prohibited by this Policy."
        }
      },
      provisionOfItems: {
        title: "4.3 Provision of items of value to government officials",
        governmentTransactionApproval: {
          title: "4.3.1 Government transaction approval tool",
          content: "Before providing an item of value to any government official or entity, employees must first obtain written approval from the Company's legal counsel."
        },
        giftsMealsTravel: {
          title: "4.3.2 Gifts, Meals, Travel and Entertainment",
          content: "No gifts, meals, travel or entertainment may be given to anyone (government officials or business partners) in exchange for any improper favor or benefit. In addition, gifts of cash or cash equivalents, such as gift cards, are not permitted."
        },
        gifts: {
          title: "4.3.3 Gifts",
          content: "No gift may be given to improperly influence a government official or in exchange for any improper favor or benefit. It may, however, be permissible to make donations directly to a government agency (rather than to an individual government official) as part of a charitable effort."
        },
        promotionDemonstration: {
          title: "4.3.4 Promotion, demonstration or explanation of products",
          content: "No advertising expenses or activities may be directed to a government official to improperly influence him or her or in return for any improper favor or benefit. In certain circumstances, however, it may be appropriate to direct such expenditures to a government official or entity in order to promote, demonstrate or explain the Company's products and services."
        },
        hiringGovernmentOfficials: {
          title: "4.3.5 Hiring or Employment of Government Officials",
          content: "No government official or members of his/her immediate family may be hired or employed to improperly influence the employee or in return for any improper favor or benefit. Please note that before hiring a government official (or his/her relative), the Company's associates must first obtain legal approval."
        },
        politicalContributions: {
          title: "4.3.6 Political Contributions",
          content: "No political contributions may be made to improperly influence a government official or in exchange for any improper favor or benefit."
        }
      },
      thirdPartyManagement: {
        title: "4.4 Third Party Management",
        applicability: {
          title: "4.4.1 Applicability to third parties",
          paragraph1: "Third party agents, consultants, distributors or any other third party representatives acting for or on behalf of the Company (collectively, \"Third Parties\") are prohibited from making Corruption Payments on behalf of the Company. This prohibition also applies to subcontractors hired by third parties to perform work on behalf of the Company.",
          paragraph2: "Any and all payments made to third parties, including commissions, reimbursements, refunds, must be customary and reasonable in relation to the services provided and must be accurately documented in the books and records of the Company. No such payment shall be made in cash or to bank accounts that are not in the name of the third party."
        },
        dueDiligence: {
          title: "4.4.2 Due Diligence",
          paragraph1: "Any and all third parties who will interact with government officials or entities on behalf of the Company must complete the Company's due diligence process before they begin working on behalf of the Company. The Procedure Documents provide a detailed overview of the third-party due diligence process.",
          paragraph2: "Any red flags raised during a vendor due diligence audit should be addressed to the satisfaction of the Company's Legal Counsel prior to entering into a relationship with the third party and any remedial action implemented should be documented in the due diligence tool. The Procedural Documents contain additional information regarding common third party red flags. Importantly, due diligence should be renewed to active suppliers every three years.",
          paragraph3: "All agreements with third parties interacting with government agencies or officials must be in writing and include appropriate anti-bribery language. The company's legal counsel will determine the appropriate contractual language.",
          paragraph4: "Once a third party agent or consultant is acquired by the Company, the activities and expenses of the third party must be monitored by the relevant Company official to ensure continued compliance with applicable anti-corruption laws and Company policies."
        }
      },
      education: {
        title: "4.5 Education",
        paragraph1: "The Company requires all directors and all employees to complete anti-bribery training every two years.",
        paragraph2: "Required anti-bribery training may include in-person or online training, a web-based anti-bribery training course, or instructor-led training programs. If a Company associate is assigned a web-based training course, he or she must complete that web-based course regardless of whether he or she has also received in-person training."
      },
      audit: {
        title: "4.7 Audit",
        content: "Company employees will conduct periodic internal audits of the Company's relevant operations to ensure the Company's continued compliance with applicable anti-bribery laws and this Policy. It is the duty of all employees to cooperate with - and never interfere with or obstruct - such audit activities or investigations of the Company. The Company's auditors are expected to act independently and to contact the Company's Legal Counsel for clarification of any questions regarding the application of this Policy."
      },
      reportingViolations: {
        title: "4.8 Reporting Violations",
        content: "If you observe conduct that may violate this Policy, contact the Company's Legal Counsel or use compliance@vidavo.eu. Suspected violations will be reviewed and investigated as appropriate and may result in disciplinary action. Any such report will be treated as confidential to the extent permitted by law. The Company strictly prohibits retaliation for good faith reports of suspected misconduct. Failure to report a violation of this Policy constitutes an independent violation of this Policy subject to disciplinary action, including, but not limited to, termination of employment."
      }
    },
    managingDirector: "Managing Director",
    name: "Markella Psymarnou"
  }
},
cookies: {
  banner: {
    title: "We use cookies",
    description: "This website uses cookies to enhance your browsing experience and provide personalized content. By clicking \"Accept All\", you agree to our use of cookies.",
    acceptAll: "Accept All",
    necessaryOnly: "Necessary Only",
    settings: "Settings"
  },
  dialog: {
    title: "Cookie Preferences",
    description: "Choose which cookies you want to accept. You can change these settings at any time.",
    necessary: {
      label: "Necessary Cookies",
      description: "Required for the website to function properly. These cookies cannot be disabled."
    },
    analytics: {
      label: "Analytics Cookies",
      description: "Help us understand how visitors use our website"
    },
    cancel: "Cancel",
    savePreferences: "Save Preferences"
  }
},
common: {
  learnMore: 'Learn more',
},
vida24HomeCare: {
  meta: {
    title: "Vida24 for Home Care | Telemonitoring for Care Homes & Healthcare",
    description: "Vida24 helps care teams capture vital signs, monitor health status in real time and coordinate care actions through one connected platform.",
    ogTitle: "Vida24 — Telemonitoring for Home Care, Care Homes and Healthcare Facilities",
    ogDescription: "One connected platform for vital signs capture, real-time monitoring and coordinated care.",
  },
  hero: {
    titlePrefix: "Telemonitoring for",
    titleItems: ["Home Care", "Care Homes", "Healthcare Facilities"],
    subtitle: "Vida24 helps care teams capture vital signs, monitor health status in real time and coordinate care actions through one connected platform.",
    requestDemo: "Request a Demo",
  },
  benefits: [
    { title: "Care in the familiar environment", text: "Continuous care at home and in care homes." },
    { title: "Real-time monitoring", text: "Capture vital signs in real time and detect changes early." },
    { title: "Better outcomes & quality of life", text: "Faster response, fewer escalations and better quality of life." },
    { title: "Connected & coordinated care", text: "Care teams, physicians and facilities work together on one platform." },
  ],
  howItWorks: {
    title: "How Vida24 Works",
    steps: [
      { title: "Measure", text: "Patients or care professionals record vital signs using connected medical devices in the home or care setting." },
      { title: "Transmit", text: "Data is securely transmitted to the Vida24 platform through Bluetooth-enabled connectivity." },
      { title: "Document", text: "Measurements are automatically assigned to the patient record, ensuring complete and accurate documentation." },
      { title: "Overview", text: "Healthcare professionals gain instant visibility into health status, trends and alerts through a centralized dashboard." },
      { title: "React", text: "Care teams can respond quickly, coordinate interventions and maintain continuous care based on real-time information." },
    ],
  },
  devices: {
    title: "Connected Medical Devices",
    subtitle: "Vida24 supports integration with a wide range of Bluetooth-enabled medical devices for remote monitoring and connected care.",
    items: [
      { name: "Glucose Meter", detail: "Accu-Chek Instant" },
      { name: "Blood Pressure Monitor", detail: "Continuous BP tracking" },
      { name: "Thermometer", detail: "Body temperature" },
      { name: "Spirometer", detail: "Breath capacity" },
      { name: "ECG Device", detail: "D-Heart" },
    ],
  },
  capabilities: {
    title: "Platform Capabilities",
    items: [
      { title: "Cloud dashboard solution", text: "Secure access anytime, anywhere." },
      { title: "Compatible with existing care software", text: "Seamless workflow integration." },
      { title: "Compatible with Bluetooth & vital sign devices", text: "Reliable and scalable device ecosystem." },
    ],
  },
  audiences: {
    title: "Who It's For",
    subtitle: "Designed to support care professionals, healthcare organizations and individuals through connected care and telemonitoring.",
    prev: "Previous audience",
    next: "Next audience",
    slide: "Go to slide",
    items: [
      { title: "For Care Teams", items: ["Capture vital signs easily", "Coordinate care actions", "Keep patients in view"] },
      { title: "For Providers & Organizations", items: ["Centralized patient overview", "Better coordination & allocation", "Scalable monitoring workflows"] },
      { title: "For Patients & Residents", items: ["Care in the familiar environment", "Continuous monitoring support", "Better care team connection"] },
    ],
  },
  reasons: {
    title: "Why organizations choose Vida24",
    items: [
      { title: "Proven Telemonitoring Platform", text: "Supporting connected care and remote monitoring workflows." },
      { title: "Multiple Device Integrations", text: "Compatible with a wide range of Bluetooth-enabled medical devices." },
      { title: "Centralized Care Management", text: "One platform for monitoring, coordination and documentation." },
      { title: "Scalable Across Care Settings", text: "Suitable for home care, care homes and healthcare facilities." },
    ],
  },
  cta: {
    title: "Ready to explore Vida24?",
    subtitle: "Let's discuss how connected care and telemonitoring can support your organization.",
    demo: "Request a Demo",
    pilot: "Start a Pilot",
    contact: "Contact Us",
  },
  contactModal: {
    titles: { demo: "Request a Demo", general: "General Inquiry", pilot: "Pilot Program" },
    subtitle: "Learn how Vida24 can support your organization through connected care and telemonitoring.",
    labels: {
      firstName: "First Name",
      lastName: "Last Name",
      organization: "Organization",
      jobTitle: "Job Title",
      country: "Country",
      email: "Email",
      phone: "Phone",
      message: "Message",
    },
    close: "Close form",
    submit: "Send Request",
  },
},
};
